import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconPointsFill = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12ZM11.6717 17.9007L8.6766 17.9137L8.67473 17.5519C8.8519 17.524 9.04026 17.4624 9.08129 17.4046C9.12232 17.3449 9.14283 17.2741 9.14283 17.1864L9.12791 7.46074C9.12791 7.37123 9.1074 7.29663 9.06824 7.24255C9.02534 7.18287 8.91531 7.14184 8.73814 7.11573V6.89007H15.8902C15.9648 6.89007 16.0226 6.85277 16.0599 6.78377C16.0972 6.71477 16.1233 6.5749 16.1438 6.35856H16.3117V9.49912H16.1438C16.1233 9.32382 16.0972 9.20446 16.0599 9.13919C16.0226 9.07578 15.9666 9.04594 15.8902 9.04594L11.2782 9.02543V10.7729L14.5139 10.7691C14.5833 10.7691 14.6359 10.686 14.6729 10.6274C14.6766 10.6215 14.6802 10.6159 14.6836 10.6106C14.7227 10.5547 14.7507 10.4372 14.7712 10.26H14.9372V13.4435H14.7712C14.7534 13.2726 14.7332 13.2462 14.7059 13.2104C14.699 13.2013 14.6915 13.1915 14.6836 13.1786C14.6444 13.1152 14.5903 13.0929 14.5139 13.0929L11.2782 13.0667V17.1286C11.2782 17.2162 11.3006 17.302 11.3416 17.3598C11.3845 17.4177 11.4945 17.524 11.6736 17.5501L11.6717 17.9007Z"
      />
    </Svg>
  );
};
